import React from "react";
import { motion } from "framer-motion";

/** Gentle, one-shot fade-up reveal on scroll — subtle, not decorative motion. */
export function Reveal({ children, delay = 0, className = "" }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.5, delay, ease: "easeOut" }}
        >
            {children}
        </motion.div>
    );
}

const BG = {
    white: "bg-white",
    soft: "bg-brand-bg",
    charcoal: "bg-brand-ink text-white",
    deepCharcoal: "bg-brand-forest text-white",
    orange: "bg-brand-action text-white",
};

export function Section({ id, bg = "white", className = "", children }) {
    return (
        <section id={id} className={`${BG[bg]} py-20 md:py-28 px-6 lg:px-12 ${className}`}>
            <div className="max-w-7xl mx-auto">{children}</div>
        </section>
    );
}

export function Eyebrow({ children, dark }) {
    return (
        <p className={`text-xs font-semibold uppercase tracking-overline mb-4 ${dark ? "text-[#FF9A5C]" : "text-brand-action"}`}>
            {children}
        </p>
    );
}
